import type { MeView, WsNotice } from "../api/types";
import type { ToastInput } from "../ui/toastStore";
import { plainNotice } from "../ui/words";

/**
 * The short message for a personal notice (the `notice` message of 2.10). The sentence is the
 * server's; the app adds a place to go when there is one.
 */
export function toastForNotice(message: WsNotice, me?: MeView | null): ToastInput {
  const toast = toastFor(message, me);
  return { ...toast, text: plainNotice(toast.text) };
}

function toastFor(message: WsNotice, me?: MeView | null): ToastInput {
  const roles = me?.active?.roles ?? [];
  const id = message.element_id ? encodeURIComponent(message.element_id) : null;
  switch (message.kind) {
    case "sent_back_to_you":
      return { text: message.text, action: { label: "Open the list", to: "/review" } };
    case "note_for_you": {
      if (id && roles.includes("sme") && !roles.includes("engineer")) return { text: message.text, action: { label: "Open the card", to: `/review?card=${id}` } };
      return { text: message.text, action: { label: "Open the list", to: "/review" } };
    }
    case "lock_release_asked":
      return { text: message.text, tone: "warning", action: id ? { label: "Open it", to: `/elements/${id}` } : undefined };
    case "your_lock_released":
      return { text: message.text, action: id ? { label: "Open it", to: `/elements/${id}` } : undefined };
    case "hand_over_arrived":
      return { text: message.text, action: { label: "Open the inbox", to: "/review" } };
    case "memory_changed":
      return { text: message.text, action: { label: "See what changed", to: "/profile" } };
    // A restore changes what many people see, and its announcement stays until it is read and dismissed (UI-27).
    case "restore_done":
      return { text: message.text, timeoutMs: 0 };
    case "intake_done":
      return { text: message.text };
  }
}
